var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemRequirements(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "system-requirements_svg__a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 131.8 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-requirements_svg__b",
    x1: 15.28,
    y1: 91.72,
    x2: 16.12,
    y2: 92.72,
    gradientTransform: "translate(-293.61 3046.73) scale(20.17 -32.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-requirements_svg__c",
    x1: 14.11,
    y1: 91.17,
    x2: 15.11,
    y2: 92.17,
    gradientTransform: "translate(-1.46 846.52) scale(8.49 -8.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m27.96,19.78l4.99,6.8c3.25,1.47,6.34,3.27,9.22,5.38l-1.19,1.86s-8.2-3.36-10.3-4.78l-3.83-6.01,1.12-3.25h0Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.02,
    cy: 33.8,
    rx: 1.53,
    ry: 2.57,
    transform: "translate(-9.16 50.25) rotate(-55.65)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.29,40.2l-1.44-2.83s.24-3.46.55-7.69l-1.1.08s.11-.66-.19-.84.02-.19.27-.46c.25-.27,0-.26-.28-.51s1.3-11.14,1.52-12.19c.12-.61.55-1.12,1.13-1.35h.37c.87-.53,3.09-2.07,3.09-2.07l1.56-2.48,3.52.26,1.17,1.96c.89.4,1.71.95,2.41,1.63.33.16.6.42.78.74.54.93,4.33,9.25,4.15,9.57s-.43.39-.11.57.62.09.4.36.08.86.08.86l-4.14,3.04c.06,4.15.08,7.6.08,7.6l1.96,2.87-.13,2.48-15.65.78v-2.38Z",
    style: {
      fill: "url(#system-requirements_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2,82.35h1.99l.95-7.68h-2.94v7.68Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.02,82.31h0c.06.18.1.37.1.56h0c0,.37-.3.67-.68.67h-6.16c-.25,0-.46-.21-.46-.46v-.26c-.17-.59-.05-1.23.32-1.72,0,0,.78.74,1.95-.42l.34-.62,2.49,1.82,1.38.17c.3.04.57,0,.72.26h0Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4,80.41l1.96.33,2.21-7.41-2.9-.49-1.27,7.57Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.13,81.5h0c.03.19.03.38,0,.57h0c-.06.37-.41.62-.78.55,0,0,0,0,0,0l-6.08-1.02c-.25-.04-.42-.28-.38-.53l.04-.25c-.07-.61.15-1.22.6-1.64,0,0,.65.86,1.99-.09l.44-.56,2.15,2.21,1.33.4c.29.09.56.09.67.37h0Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.48,41.02s2.67,3.13,2.67,6,.07,11.88.07,11.88c0,0-1.57,14.07-1.96,15.25-.29,1.02-.48,2.07-.59,3.13l-3.78-.91s-.52-13.24,1.04-16.37l-3.78-10.7-1.3,30.26h-4.4s-2.26-15.91-1.09-20.08c0,0-2.61-15.91-1.96-16.83s15.07-1.63,15.07-1.63h0Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.36,
    cy: 4.93,
    r: 4.43,
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9,1.36c-.24-.63-.85-1.04-1.53-1.01h-.09c-.34-.04-.67-.11-1-.2-.63-.13-1.28-.09-1.89.12-.18.08-.38.13-.57.15-.2.01-.39-.11-.46-.3l-.04.52-.19-.42-.13.56-.41-.47c.02.21-.07.42-.25.55-.17.12-.36.22-.56.29-.87.31-1.55.99-1.86,1.86-.11.56-.11,1.14,0,1.71.04.51.18,1,.42,1.45.21.25.39.52.53.81.04.3.11.59.2.88.17.26.42.44.72.52.29.08.58.2.84.35.25.18.53.69,1.07.66l.17-.33c.18-.15-.48-.03-.49-.26s.79-.37.68-.57c-.17-.31-.41-.57-.61-.87-.26-.33-.38-.75-.33-1.16.03-.16.11-.32.22-.43.33-.34.71-.19,1.07-.14.25.06.51-.02.68-.22.15-.25-.02-.57,0-.87.05-.31.24-.59.51-.74.27-.15.53-.33.78-.52.25-.2.37-.52.3-.84.73-.44,1.62-.52,2.42-.22-.06-.29-.13-.57-.23-.85h0Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.18,58.08v-13.46c0-.72.57-1.3,1.29-1.31.05,0,.1,0,.15,0,3.2-.54,6.49-.19,9.51,1,.33,0,.6.27.6.6h0v13.51c0,.33-.27.6-.6.6h0c-3.3-.65-6.7-.65-10.01,0-.52,0-.94-.42-.94-.95h0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.18,59.28v-13.6c0-.72.58-1.3,1.3-1.3,3.16-.85,6.49-.85,9.65,0,.33,0,.6.27.6.6h0v13.37c0,.33-.27.6-.6.6h0c-3.39-.46-6.84-.02-10.01,1.29-.52,0-.94-.42-.94-.95h0Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.69,49.99h-3.04c-1.09,0-1.98-.89-1.98-1.98s.89-1.98,1.98-1.98h3.04c1.09,0,1.98.89,1.98,1.98s-.89,1.98-1.98,1.98Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m17.48,23.27l-.12,7.02s-.37,5.47-1.29,11.63l-2.2.14s.27-9.62.17-12.15l.16-5.62,3.28-1.03Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.09,
    cy: 43.71,
    rx: 1.53,
    ry: 2.57,
    transform: "translate(-1.48 .54) rotate(-1.95)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.24,77.08h-45.09c-.26,0-.52-.04-.77-.12h-.03c-14.12-7.03-26.22-10.86-37-11.72h-.04c-1.06-.34-1.79-1.33-1.78-2.44V2.55C44.54,1.14,45.68,0,47.09,0c.26,0,.52.04.77.12l35.64,11.27c.21.07.44.1.66.1h45.08c1.41,0,2.55,1.14,2.55,2.55v60.48c0,1.41-1.14,2.55-2.55,2.55Zm-45.73-.47c.21.07.43.1.64.1h45.09c1.21,0,2.18-.98,2.18-2.18V14.05c0-1.21-.98-2.18-2.18-2.18h-45.09c-.26,0-.52-.04-.77-.12L47.74.47c-1.15-.36-2.38.27-2.74,1.42-.07.21-.1.43-.1.66v60.25c0,.95.61,1.78,1.51,2.08,10.82.87,22.96,4.71,37.1,11.74h0Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.36,74.35c12.29-4.35,26.01-3.85,40.58-.43,1.56.37,3.13-.59,3.5-2.16.05-.22.08-.44.08-.67V16.03c0-1.34-.91-2.5-2.21-2.82-15.37-3.76-29.73-4.45-42.38.02-.93.32-1.96.15-2.74-.44C71.54,4.67,60.63.6,49.39,1.81c-1.47.16-2.58,1.41-2.58,2.89v55.65c0,1.49,1.13,2.74,2.61,2.89,11.82,1.27,23.24,4.98,33.54,10.91.73.41,1.61.48,2.4.2h0Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.97,71.26c-.84,0-1.67-.24-2.39-.68-8.48-5.32-18.12-8.53-28.11-9.36-2.35-.21-4.16-2.18-4.17-4.54V9.14c-.01-2.43,1.89-4.43,4.31-4.55,7.26-.34,16.07,2.9,27.74,10.18.98.61,2.17.8,3.29.5,11.08-2.98,23.1-3.06,36.74-.27,2.12.44,3.64,2.3,3.65,4.47v46.4c0,2.52-2.05,4.56-4.57,4.55-.36,0-.72-.04-1.06-.13-12.9-3.07-23.97-2.85-33.86.68h0c-.5.18-1.03.27-1.57.27h0ZM55.65,4.94c-.34,0-.68,0-1.02.02-2.23.11-3.97,1.95-3.95,4.18v47.54c0,2.17,1.67,3.98,3.83,4.17,10.04.83,19.74,4.06,28.27,9.42,1.09.68,2.43.81,3.64.37l.06.17-.06-.17c9.95-3.55,21.1-3.78,34.07-.69,2.25.54,4.52-.84,5.06-3.09.08-.32.12-.65.12-.98V19.48c0-1.99-1.41-3.7-3.36-4.11-13.58-2.78-25.54-2.7-36.57.26-1.22.32-2.52.12-3.58-.55-11.05-6.9-19.52-10.15-26.51-10.15h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.01,
    y: 15.55,
    width: 0.37,
    height: 55.62,
    transform: "translate(-.39 .76) rotate(-.52)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.59,
    y: 2.72,
    width: 0.37,
    height: 27.23,
    transform: "translate(30.29 74.59) rotate(-71.69)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.59,
    y: 9.57,
    width: 0.37,
    height: 27.23,
    transform: "translate(23.79 79.29) rotate(-71.69)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.59,
    y: 16.41,
    width: 0.37,
    height: 27.23,
    transform: "translate(17.29 83.98) rotate(-71.69)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.59,
    y: 23.26,
    width: 0.37,
    height: 27.23,
    transform: "translate(10.79 88.68) rotate(-71.69)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 20.81,
    width: 30.99,
    height: 0.37,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 27.27,
    width: 30.99,
    height: 0.37,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 33.74,
    width: 30.99,
    height: 0.37,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 40.2,
    width: 30.99,
    height: 0.37,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 46.67,
    width: 30.99,
    height: 0.37,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 53.13,
    width: 30.99,
    height: 0.37,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.01,80.8c-.23,0-.43-.17-.43-.4,0-.12.04-.24.13-.32l.03-.11v-.03c-.25-.57-.91-.84-1.49-.6-.27.12-.49.33-.6.61-.4.79-.7,1.63-.88,2.5-.05.38-.03.77.06,1.14-.8-1.74-1.21-3.63-1.21-5.54,0-.48.03-.96.08-1.44.04-.39.11-.78.18-1.17.43-2.09,1.35-4.05,2.68-5.72.64-.35,1.17-.89,1.49-1.55.12-.24.2-.49.25-.75-.14-.37-.22-.77-.22-1.17-.1-.15-.28-.23-.39-.38-.55-.75-1.31-.62-1.71.4-.85.43-.85,1.14-.34,1.82.33.43.38,1.02.67,1.48l-.09.11c-.54.7-1.02,1.45-1.42,2.25.1-.89-.02-1.79-.34-2.62-.39-.77-.88-1.47-1.46-2.11-.39-.5-1.12-.59-1.63-.2-.24.19-.4.47-.44.77v.03c.08.04.16.09.23.14.26.17.33.53.16.79-.09.13-.23.22-.39.25h-.01c.03.29.08.57.15.85-.68,2.64.79,3.61,2.9,3.65l.14.07c-.4,1.13-.65,2.32-.75,3.51-.05.71-.05,1.42.01,2.12v-.02c-.15-.79-.58-1.5-1.19-2.01-1.02-.62-2.09-1.16-3.19-1.63-.3-.2-.71-.11-.9.19-.08.13-.12.29-.1.44v.03c.15.06.29.13.43.21.08.04.16.09.23.14.26.17.33.53.16.79-.09.13-.23.22-.39.25h-.04c.25.6.6,1.15,1.04,1.63.43,2.31,2.26,2.53,4.23,1.86h0c.22.94.53,1.85.93,2.72h3.33s.02-.08.03-.11c-.31.02-.62,0-.92-.05l.74-.91.02-.02.38-.46h0c0-.48-.05-.95-.16-1.41h0Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.23,83.78c0,.12-.1.22-.22.22H.24c-.12,0-.22-.1-.22-.22s.1-.22.22-.22h46.77c.12,0,.22.1.22.22,0,0,0,0,0,0h0Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 122.65,
    cy: 67.85,
    r: 4.25,
    style: {
      fill: "url(#system-requirements_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.64,67.69l-2.64-1.52c-.09-.05-.2-.02-.25.07-.02.03-.02.06-.02.09v1.34h-.79c-.1,0-.19.07-.2.17,0,.1.07.19.17.2,0,0,.02,0,.03,0h.79v1.34c0,.1.08.18.19.18.03,0,.06,0,.09-.02l2.64-1.52c.09-.05.12-.17.07-.25-.02-.03-.04-.05-.07-.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62.17,55.87c.17-1.9.95-3.7,2.21-5.12,1.96-2.18,4.88-3.24,7.78-2.84.24.04.24.42,0,.39-1.75-.25-3.53.05-5.1.86-2.55,1.33-4.24,3.86-4.5,6.73-.02.25-.41.24-.39,0h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.72,46.36l2.98,1.47c.09.06.12.18.06.28,0,.01-.02.02-.02.03l-2.83,2.34c-.19.16-.46-.12-.27-.28l2.83-2.34.03.31-2.98-1.47c-.22-.11-.02-.44.2-.33h0Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemRequirements);
export default __webpack_public_path__ + "static/media/system-requirements.970715fbfaab12b5620e4f566f7acf19.svg";
export { ForwardRef as ReactComponent };